export var NAME = 'invoice';
export var FAPIAO_CANCELLED = "".concat(NAME, "/FAPIAO_CANCELLED");
export var FILTERS_CHANGED = "".concat(NAME, "/FILTERS_CHANGED");
export var INVOICE_LOADED = "".concat(NAME, "/INVOICE_LOADED");
export var PAGE_CHANGED = "".concat(NAME, "/PAGE_CHANGED");
export var SELECTED_INVOICES_CLEARED = "".concat(NAME, "/SELECTED_INVOICES_CLEARED");
export var SELECTIONS_UPDATED = "".concat(NAME, "/SELECTIONS_UPDATED");